import external from './external';
import portal from './portal';

export default {
  portal,
  external,
};
